import { render, staticRenderFns } from "./SingleGrade.vue?vue&type=template&id=226ae207&scoped=true"
import script from "./SingleGrade.vue?vue&type=script&lang=ts"
export * from "./SingleGrade.vue?vue&type=script&lang=ts"
import style0 from "./SingleGrade.vue?vue&type=style&index=0&id=226ae207&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226ae207",
  null
  
)

export default component.exports